(() => {
  if (window.__sbPdpEditorialZoomLoaded) return;
  window.__sbPdpEditorialZoomLoaded = true;

  const ROOT_SELECTOR = '.sb-prod-editorial';
  const LOOK_SELECTOR = '.sb-pe-look';
  const HERO_SELECTOR = '.sb-pe-hero-main img, .sb-pe-hero-main picture img, img[id^="sb-pe-hero-img"]';
  const CAPTION_SELECTOR = '.sb-pe-hero-caption, [id^="sb-pe-hero-caption"], #sbEdHeroCaption, #sbPeHeroCaption, #sbPeHydraCap';
  const READY_ATTR = 'data-sb-pdp-zoom-ready';
  const MODAL_ID = 'sb-pdp-zoom-modal';

  let modal;
  let modalImage;
  let modalCaption;
  let modalClose;
  let lastTrigger;

  function normalizeSrc(src) {
    if (!src) return '';
    return src.replace(/modelo-pc-(\d{2})-close\.png/gi, 'modelo-pc-$1-antes-depois.png');
  }

  function getImageFromLook(look, root, hero) {
    const thumb = look.querySelector('img');
    const model = look.getAttribute('data-model');
    let src = look.getAttribute('data-src') || look.getAttribute('data-full-src') || look.getAttribute('data-image') || '';

    if (!src && thumb) {
      src = thumb.currentSrc || thumb.src || thumb.getAttribute('src') || '';
    }

    if (!src && model && hero) {
      const heroSrc = hero.currentSrc || hero.src || hero.getAttribute('src') || '';
      const query = heroSrc.includes('?') ? heroSrc.slice(heroSrc.indexOf('?')) : '';
      const base = heroSrc.includes('/') ? heroSrc.slice(0, heroSrc.lastIndexOf('/') + 1) : '';
      src = base + model + query;
    }

    const label =
      look.getAttribute('data-label') ||
      look.getAttribute('data-caption') ||
      look.querySelector('span')?.textContent.trim() ||
      thumb?.getAttribute('alt') ||
      '';

    const alt =
      look.getAttribute('data-alt') ||
      thumb?.getAttribute('alt') ||
      label ||
      hero?.getAttribute('alt') ||
      '';

    return {
      src: normalizeSrc(src),
      alt,
      label,
      root,
    };
  }

  function getHeroState(root) {
    const hero = root.querySelector(HERO_SELECTOR);
    const caption = root.querySelector(CAPTION_SELECTOR);
    return {
      src: normalizeSrc(hero?.currentSrc || hero?.src || hero?.getAttribute('src') || ''),
      alt: hero?.getAttribute('alt') || '',
      label: caption?.textContent.trim() || '',
      root,
    };
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.getElementById(MODAL_ID);
    if (!modal) {
      modal = document.createElement('div');
      modal.id = MODAL_ID;
      modal.className = 'sb-pdp-zoom-modal';
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = `
        <div class="sb-pdp-zoom-modal__dialog" role="dialog" aria-modal="true" aria-label="Imagem ampliada do produto">
          <button class="sb-pdp-zoom-modal__close" type="button" aria-label="Fechar imagem ampliada">×</button>
          <img class="sb-pdp-zoom-modal__image" alt="">
          <span class="sb-pdp-zoom-modal__caption"></span>
        </div>
      `;
      document.body.appendChild(modal);
    }

    modalImage = modal.querySelector('.sb-pdp-zoom-modal__image');
    modalCaption = modal.querySelector('.sb-pdp-zoom-modal__caption');
    modalClose = modal.querySelector('.sb-pdp-zoom-modal__close');

    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('.sb-pdp-zoom-modal__close')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    return modal;
  }

  function openModal(state, trigger) {
    if (!state?.src) return;
    ensureModal();
    lastTrigger = trigger || document.activeElement;

    modalImage.src = state.src;
    modalImage.alt = state.alt || '';
    modalCaption.textContent = state.label || state.alt || '';
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    modalClose.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  function updateHero(root, state) {
    const hero = root.querySelector(HERO_SELECTOR);
    const caption = root.querySelector(CAPTION_SELECTOR);
    const heroShell = root.querySelector('.sb-pe-hero-main');
    if (!hero || !state?.src) return;

    hero.style.opacity = '0';
    window.setTimeout(() => {
      hero.src = state.src;
      if (state.alt) hero.alt = state.alt;
      hero.style.opacity = '1';
    }, 90);

    if (caption && state.label) caption.textContent = state.label;
    if (heroShell && state.label) heroShell.setAttribute('aria-label', `Abrir imagem ampliada: ${state.label}`);
  }

  function setActive(root, activeLook) {
    root.querySelectorAll(LOOK_SELECTOR).forEach((look) => {
      look.classList.toggle('is-active', look === activeLook);
      if (look === activeLook) {
        look.setAttribute('aria-current', 'true');
        look.setAttribute('aria-pressed', 'true');
      } else {
        look.removeAttribute('aria-current');
        look.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function normalizeRoot(root) {
    if (!root || root.hasAttribute(READY_ATTR) || !root.querySelector(LOOK_SELECTOR)) return;

    root.setAttribute(READY_ATTR, 'true');
    root.classList.add('sb-pdp-editorial-standard');

    const heroShell = root.querySelector('.sb-pe-hero-main');
    if (heroShell) {
      heroShell.setAttribute('role', 'button');
      heroShell.setAttribute('tabindex', '0');
      heroShell.classList.add('sb-pdp-editorial-standard__hero');
      if (!heroShell.getAttribute('aria-label')) heroShell.setAttribute('aria-label', 'Abrir imagem ampliada');
    }

    root.querySelectorAll(LOOK_SELECTOR).forEach((look) => {
      if (!look.getAttribute('type') && look.tagName === 'BUTTON') look.setAttribute('type', 'button');
      look.setAttribute('aria-pressed', look.classList.contains('is-active') ? 'true' : 'false');
      if (look.classList.contains('is-active')) look.setAttribute('aria-current', 'true');
    });
  }

  function handleLookClick(event) {
    const look = event.target.closest(LOOK_SELECTOR);
    if (!look) return;

    const root = look.closest(ROOT_SELECTOR);
    if (!root) return;

    normalizeRoot(root);
    const hero = root.querySelector(HERO_SELECTOR);
    const state = getImageFromLook(look, root, hero);
    if (!state.src) return;

    setActive(root, look);
    updateHero(root, state);
    openModal(state, look);
  }

  function handleHeroOpen(event) {
    const heroShell = event.target.closest('.sb-pe-hero-main');
    if (!heroShell || event.target.closest(LOOK_SELECTOR) || event.target.closest('button, a, input, select, textarea')) return;

    const root = heroShell.closest(ROOT_SELECTOR);
    if (!root || !root.querySelector(LOOK_SELECTOR)) return;

    normalizeRoot(root);
    openModal(getHeroState(root), heroShell);
  }

  function handleHeroKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const heroShell = event.target.closest('.sb-pe-hero-main');
    if (!heroShell) return;

    const root = heroShell.closest(ROOT_SELECTOR);
    if (!root || !root.querySelector(LOOK_SELECTOR)) return;

    event.preventDefault();
    normalizeRoot(root);
    openModal(getHeroState(root), heroShell);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(normalizeRoot);
    ensureModal();
  }

  document.addEventListener('click', handleLookClick);
  document.addEventListener('click', handleHeroOpen);
  document.addEventListener('keydown', handleHeroKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
